import React, { Component } from 'react';
import Modal from 'js/components/global/Modal';
import { VacationContext } from 'js/components/step1/VacationContext';

class PointsOfferModalWrapper extends Component {
  render() {

    const brandURL = window._app.brandOptions.url;

    return (
      <VacationContext.Consumer>
        {(context) => (
          <Modal
            className="vw-vctn fok-title points-offer-modal"
            isOpen={context.state.isModalOpen.pointsOffer}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={context.closeModal('pointsOffer')}
            contentLabel="Privacy Policy Modal"
          >
            <h2 className="popup-title">SANDALS SELECT COLUMBUS DAY OFFER</h2>
            <p>
              Exclusive SSR Offer! Sandals Select Members booking during this promotional period can instantly qualify
              to earn and burn 5,000 Sandals Select Reward points when calling or booking online.
            </p>

            <p>
              <b>Offer:</b> Earn & Burn 5,000 Points at the time of booking
              <span className="d-block">Applicable Markets: US/CA/LATAM </span>
              <span className="d-block">Resorts: All Sandals & Beaches Resorts</span>
              <span className="d-block">Min. length of stay: Six (6) PAID Nights</span>
            </p>

            <p>
              <b>Room Categories: All Categories</b>
              <span className="d-block">Booking Window October 10 – October 16, 2020</span>
              <span className="d-block">Travel Window: October 10 – December 26, 2021 **Blackout & Resort Re-opening Dates apply</span>
            </p>

            <p>
              <b>Blackout Dates: </b>
              <span className="d-block">Sandals:</span>
              <span className="d-block">December 27, 2020 – December 31, 2020</span>
              <span className="d-block">December 27, 2021 – December 31, 2021</span>
            </p>

            <p>
              <span className="d-block">Beaches:</span>
              <span className="d-block">November 21, 2020 – November 27, 2020 (Beaches Turks and Caicos only)</span>
              <span className="d-block">December 16, 2020 – December 31, 2020</span>
              <span className="d-block">February 12, 2021 – February 21, 2021</span>
              <span className="d-block">March 13, 2021 – April 11, 2021</span>
              <span className="d-block">November 20, 2021 – November 26, 2021 (Beaches Turks and Caicos only)</span>
              <span className="d-block">December 21, 2021 – December 31, 2021</span>
            </p>

            <p>
              <b>IMPORTANT NOTE:</b> As a requirement to receive the offer, one must register their booking within 72
              hours on <a href="https://www.sandals.com/specials/columbus-day-sale-registration/" className="bold-link" target="_blank">https://www.sandals.com/specials/columbus-day-sale-registration/</a> OR <a href="https://www.beaches.com/deals/columbus-day-sale-registration/" className="bold-link" target="_blank">https://www.beaches.com/deals/columbus-day-sale-registration/</a>
              <span className="d-block">To be eligible for this promotion guests must fulfill the following conditions:</span>
              <span className="d-block">1. Offer is valid for new bookings only.</span>
              <span className="d-block">2. Booking must meet all the criteria in order to qualify for promotion.</span>
              <span className="d-block">3. Offer valid for bookings made during October 10, 2020 – October 16, 2020, based on booked date not deposit.</span>
              <span className="d-block">4. Offer valid for travel between October 10, 2020 – December 26, 2021; blackout dates apply.</span>
              <span className="d-block">5. Offer valid for all room categories at any Sandals or Beaches Resorts.</span>
              <span className="d-block">6. The exclusive Sandals Select Rewards offer, of earning and redeeming 5,000 SSR points is for Sandals Select members only booking any room category of 6-nights or longer for travel October 10, 2020 – December 26, 2021.</span>
              <span className="d-block">7. Qualifying bookings may be eligible to earn 5,000 SSR points at time of booking.</span>
              <span className="d-block">8. To receive the Sandals Select Rewards offer, one must provide their SSG number at the time of booking.</span>
              <span className="d-block">9. Offer of 5,000 SSR points will be earned, applied, and redeemed at time of booking.</span>
              <span className="d-block">10. SSR Members may combine additional points up to the allowed limit of 25% of the land booking. Please refer to program.</span>
              <span className="d-block">11. Sandals Select Members failure to book using their SSG login is responsible for notifying us by calling 1-800-SANDALS, 1-800-BEACHES, to update your SSG number before their stay at Sandals and Beaches Resorts.</span>
              <span className="d-block">12. Blackout Dates and Travel Dates are as specified in our Standard Promotional Conditions.</span>
              <span className="d-block">13. Promotion exceptions will only be made on a case-by-case basis.</span>
              <span className="d-block">14. The offers have no cash value and cannot be sold, exchanged, or transferred to another booking.</span>
              <span className="d-block">15. This promotion is not applicable to contracted Groups.</span>
              <span className="d-block">16. Offer is subject to change and can be withdrawn at any time.</span>
              <span className="d-block">17. Unique Vacations and Sandals Resorts are not responsible for errors and omissions.</span>
            </p>

            <p>
              This offer is not combinable with Loyalty & Travel Desk Discounts Promotion but is combinable with all of our Standard Promotions (Including our Seasonal Promotions) and Standard Resort Offers. This promotion is also subject to our Standard Promotional Conditions including blackout dates. In addition, this promotion is subject to the conditions set out by our Standard Disclaimers.
              <span className="d-block">STANDARD DISCLAIMERS Link Reference: <a href={`https:${brandURL}/disclaimers/columbusday2020/`} className="bold-link" target="_blank">https:{brandURL}/disclaimers/columbusday2020/</a></span>
            </p>
          </Modal>
        )}
      </VacationContext.Consumer>
    );
  }
}

export default PointsOfferModalWrapper;



// WEBPACK FOOTER //
// ./js/components/step1/PointsOfferModalWrapper.js